/* eslint-disable no-underscore-dangle */
import { Component, AfterViewInit, Input, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { HisAuthService, HisBaseGlobalsService } from 'hisng';

import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { DataDictionaryUtils } from 'app/fs/res/common/utils/data-dictionary-utils';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { Publication } from 'app/fs/res/publication/model/publication';
import { DynamicContentUtils } from 'app/fs/res/common/service/dynamic-content/dynamic-content-utils';

@Component( {
    selector: 'res-publication-edit-access-data',
    templateUrl: './publication-edit-access-data.component.html',
    providers: [ProviderManager.getComponentProvider(PublicationEditAccessDataComponent)],
} )
export class PublicationEditAccessDataComponent implements AfterViewInit {
    @Input() publication: Publication;
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    constructor(
        public auth: HisAuthService,
        public hisBaseGlobalsService: HisBaseGlobalsService,
        public dynamicContentUtils: DynamicContentUtils,
        private ddUtils: DataDictionaryUtils) {
    }

    ngAfterViewInit() {
        // trigger re-render count of ViewChildren dynamicFieldContainer
        this.fieldViewContainerList.changes.subscribe( (changes: any) => {
            // eslint-disable-next-line no-underscore-dangle
            if ( this.publication._dynamicComponent && this.hisBaseGlobalsService.isAnyModuleActive( 'HISINONERES' ) ) {
                // eslint-disable-next-line no-underscore-dangle
                this.publication._dynamicComponent = { ...this.publication._dynamicComponent };
            }
            console.log( 'fieldViewContainerList.toArray().length: ', this.fieldViewContainerList.toArray().length );
        } );
    }

    public getIsDynamicContainerVisible( source: string ): boolean {
        return this.ddUtils.isVisible( this.getDdKey( source ) );
    }

    public getDdKey( source: string ): string {
        return DataDictionaryUtils.dDKeyPublicationType( this.publication.publicationType, source );
    }

    /* clear <p-autoComplete> field */
    public onClear( field: string ) {
        switch ( field ) {
            case 'access': this.publication.access = null; break;
            case 'accessAfterEmbargoDate': this.publication.accessAfterEmbargoDate = null; break;
            case 'license': this.publication.license = null; break;
            default: console.log( 'ERROR: Unsupported field:', field );
        }
    }
}
